// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"768b87e6","453":"811b880d","517":"8085a1b9","533":"b09b111a","787":"4ff1c972","958":"b772a150"}[chunkId] + ".chunk.js";
};